import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faBars } from "@fortawesome/free-solid-svg-icons";

import Tooltip from "@material-ui/core/Tooltip";
import Sidebar from './Side/sidebar'

import {
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { updateWindowWidth } from "actions/Setting";

import Content from "./Content";

import { Container, Burguer } from "./styles";
import { MODULE_LIST } from "../modules";

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black,
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
    },
}));

function BootstrapTooltip(props) {
    const classes = useStylesBootstrap();

    return <Tooltip arrow classes={classes} {...props} />;
}

class SideNav extends React.PureComponent {
    state = {
        collapsed: true,
        showTitle: false,
    };

    componentDidMount() {
        window.addEventListener("resize", () => {
            this.props.updateWindowWidth(window.innerWidth);
        });
    }

    handleCollapse = (state) => {
        this.setState({ collapsed: state });

        if (state === true) this.setState({ showTitle: false });
        else
            setTimeout(() => {
                this.setState({ showTitle: true });
            }, 150);
    };

    render() {
        const { drawerType, width, navigationStyle } = this.props;
        const { collapsed, showTitle } = this.state;

        let drawerStyle = drawerType.includes(FIXED_DRAWER)
            ? "d-xl-flex"
            : drawerType.includes(COLLAPSED_DRAWER)
            ? ""
            : "d-flex";
        let type = "permanent";

        if (
            drawerType.includes(COLLAPSED_DRAWER) ||
            (drawerType.includes(FIXED_DRAWER) && width < 1200)
        ) {
            type = "temporary";
        }
        if (navigationStyle === HORIZONTAL_NAVIGATION) {
            drawerStyle = "";
            type = "temporary";
        }

        return (
            <div id="sidebar">
                <Sidebar />
                {/* <Container
                    className="app-sidebar-content"
                    variant={type}
                    classes={{
                        paper: `side-nav justify-content-between ${
                            !collapsed && "side-nav-toggled"
                        }`,
                    }}
                >
                    <Content
                        showTitle={showTitle}
                        onCollapse={this.handleCollapse}
                    />

                    <BootstrapTooltip
                        title={!collapsed ? "Expandir" : "Retrair"}
                        placement="right-end"
                    >
                        <Burguer
                            onClick={() => this.handleCollapse(!collapsed)}
                            collapsed={collapsed}
                        >
                            <FontAwesomeIcon
                                icon={collapsed ? faBars : faChevronLeft}
                                size="lg"
                            />
                        </Burguer>
                    </BootstrapTooltip>
                </Container> */}
            </div>
        );
    }
}

const mapStateToProps = ({ auth, settings }) => {
    const { drawerType, width, navigationStyle } = settings;

    return { auth, drawerType, width, navigationStyle };
};

export default withRouter(
    connect(mapStateToProps, { updateWindowWidth })(SideNav)
);
